import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

// Single reveal helper. Wraps children in a motion div that lifts in on
// viewport intersection. `delay` is in seconds.
export default function Reveal({ children, delay = 0, y = 16, as = 'div', ...rest }) {
  const reduce = useReducedMotion();
  const Cmp = motion[as] || motion.div;
  return (
    <Cmp
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay, ease: [0.16, 0.84, 0.44, 1] }}
      {...rest}
    >
      {children}
    </Cmp>
  );
}
